import { tlStore } from "../CorBase/CoreBase";

import translationModConCS from '../../src/BaseLocales/moduleCon/SharedResourcesCON.cs.json';
import translationModConDE from '../../src/BaseLocales/moduleCon/SharedResourcesCON.de.json';
import translationModConEN from '../../src/BaseLocales/moduleCon/SharedResourcesCON.en.json';
import translationModConSK from '../../src/BaseLocales/moduleCon/SharedResourcesCON.sk.json';

import translationModCorCS from '../../src/BaseLocales/moduleCor/SharedResourcesCOR.cs.json';
import translationModCorDE from '../../src/BaseLocales/moduleCor/SharedResourcesCOR.de.json';
import translationModCorEN from '../../src/BaseLocales/moduleCor/SharedResourcesCOR.en.json';
import translationModCorSK from '../../src/BaseLocales/moduleCor/SharedResourcesCOR.sk.json';

import translationModAccCS from '../../src/BaseLocales/moduleAcc/SharedResourcesACC.cs.json';
import translationModAccDE from '../../src/BaseLocales/moduleAcc/SharedResourcesACC.de.json';
import translationModAccEN from '../../src/BaseLocales/moduleAcc/SharedResourcesACC.en.json';
import translationModAccSK from '../../src/BaseLocales/moduleAcc/SharedResourcesACC.sk.json';

import translationModShpCS from '../../src/BaseLocales/moduleShp/SharedResourcesSHP.cs.json';
import translationModShpDE from '../../src/BaseLocales/moduleShp/SharedResourcesSHP.de.json';
import translationModShpEN from '../../src/BaseLocales/moduleShp/SharedResourcesSHP.en.json';
import translationModShpSK from '../../src/BaseLocales/moduleShp/SharedResourcesSHP.sk.json';

import translationModStuCS from '../../src/BaseLocales/moduleStu/SharedResourcesSTU.cs.json';
import translationModStuDE from '../../src/BaseLocales/moduleStu/SharedResourcesSTU.de.json';
import translationModStuEN from '../../src/BaseLocales/moduleStu/SharedResourcesSTU.en.json';
import translationModStuSK from '../../src/BaseLocales/moduleStu/SharedResourcesSTU.sk.json';

export class PrepareTranslate {

	private allowAdd(module: string, langCode: string, languageList: any, useModules: any[], importLang: any, i18n: any): void {
		if ((languageList as Array<any>).indexOf(langCode) != -1 && useModules.indexOf(module) != -1) {		
			i18n.mergeLocaleMessage(langCode, importLang);
		}
	}

	private allowNotControlAdd(langCode: string, languageList: any, importLang: any, i18n: any): void {
		if ((languageList as Array<any>).indexOf(langCode) != -1 ) {
			i18n.mergeLocaleMessage(langCode, importLang);
		}
	}

	public addLangByModule(moduleList: any, languageList: any, i18n: any): void {
		
        var useModules: string[] = [];
        for (var i = 0; i < moduleList.length; i++) {

			if (moduleList[i].identifier != undefined) {
				var module = moduleList[i].identifier.substr(0, 3);

				if (useModules.indexOf(module) == -1) {
					useModules.push(module);
				}
			}
		}

		//Nacteni podle prirazeneho modulu a jazku

		//pridani prekladu napr. mam module STU, tak dostanu povoleni i pro ACC
		if (useModules.indexOf('STU') != -1 || useModules.indexOf('ACC') == -1) {
			useModules.push('ACC');
		}

		//tady vzdy nactu COR a neberu v potaz zda ma tento modul..
		this.allowNotControlAdd('CS', languageList,  translationModCorCS, i18n);
		this.allowNotControlAdd('EN', languageList,  translationModCorEN, i18n);
		this.allowNotControlAdd('DE', languageList,  translationModCorDE, i18n);
		this.allowNotControlAdd('SK', languageList,  translationModCorSK, i18n);

		this.allowAdd('CON', 'CS', languageList, useModules, translationModConCS, i18n);
		this.allowAdd('CON', 'EN', languageList, useModules, translationModConEN, i18n);
		this.allowAdd('CON', 'DE', languageList, useModules, translationModConDE, i18n);
		this.allowAdd('CON', 'SK', languageList, useModules, translationModConSK, i18n);

		this.allowAdd('ACC', 'CS', languageList, useModules, translationModAccCS, i18n);
		this.allowAdd('ACC', 'EN', languageList, useModules, translationModAccEN, i18n);
		this.allowAdd('ACC', 'DE', languageList, useModules, translationModAccDE, i18n);
		this.allowAdd('ACC', 'SK', languageList, useModules, translationModAccSK, i18n);

		this.allowAdd('SHP', 'CS', languageList, useModules, translationModShpCS, i18n);
		this.allowAdd('SHP', 'EN', languageList, useModules, translationModShpEN, i18n);
		this.allowAdd('SHP', 'DE', languageList, useModules, translationModShpDE, i18n);
		this.allowAdd('SHP', 'SK', languageList, useModules, translationModShpSK, i18n);

		this.allowAdd('STU', 'CS', languageList, useModules, translationModStuCS, i18n);
		this.allowAdd('STU', 'EN', languageList, useModules, translationModStuEN, i18n);
		this.allowAdd('STU', 'DE', languageList, useModules, translationModStuDE, i18n);
		this.allowAdd('STU', 'SK', languageList, useModules, translationModStuSK, i18n);

	}
}

export function getActualLocalizationString(): string | null {
	return tlStore.state.currentLanguage;
}
